import React, { useState, useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../../../../authConfig';
import Loading from '../../core/Loading';
import Alerts from '../../core/Alerts';
import LogoAtresmedia from '../../../../assets/images/logoatresmedia.svg';
import {
  StyledWrapper,
  StyledWrapperLogin,
  StyledLogo,
  StyledTextLogin
  // StyledLogoRazor
} from './style';
import { loginAzure } from '../../../utils/apiLogin';
import { REDIRECT_PATH_KEY } from '../../../utils/session';

const RedirectActiveDirectory = props => {
  const [fromPathname, setFromPathname] = useState('');
  const [isValidUser, setIsValidUser] = useState(true);
  const [errorCode, setErrorCode] = useState(null);
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance, accounts } = useMsal();

  useEffect(() => {
    if (props.location && props.location.state) {
      const fromPathname = props.location.state.from.pathname;
      setFromPathname(fromPathname);
    }

    if (
      (inProgress === InteractionStatus.None ||
        inProgress === InteractionStatus.Startup) &&
      !isAuthenticated
    ) {
      if (accounts.length === 0) {
        instance.loginRedirect();
      }
    } else if (accounts.length > 0 && isAuthenticated) {
      // Deja fijada la cuenta activa en cuanto hay sesión, para que el resto
      // de la app (el logout, entre otros) no dependa del orden en que
      // getAllAccounts() devuelva las cuentas.
      if (!instance.getActiveAccount()) {
        instance.setActiveAccount(accounts[0]);
      }
      // eslint-disable-next-line no-use-before-define
      getUserDetails();
    }
  }, [props.location, isAuthenticated]);

  const storeUserWidget = async data => {
    let res = false;
    const { ipcRenderer } = window.require('electron');
    const stored = await ipcRenderer.sendSync('stored-loggin', data);
    if (stored) {
      res = true;
    }
    return res;
  };

  const getUserDetails = async () => {
    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: instance.getActiveAccount() || accounts[0]
      });

      const graphResponse = await fetch(
        'https://graph.microsoft.com/v1.0/me?$select=mail,onPremisesSamAccountName',
        {
          headers: {
            Authorization: `Bearer ${response.accessToken}`
          }
        }
      );

      if (graphResponse.ok) {
        const userData = await graphResponse.json();
        const data = {
          username: userData.onPremisesSamAccountName,
          email: userData.mail
        };
        // eslint-disable-next-line no-use-before-define
        onLogin(data);
      } else {
        console.error(
          'Error al obtener los detalles del usuario:',
          graphResponse.statusText
        );
      }
    } catch (error) {
      console.error(
        'Error al realizar alconsultar datos del usuario en Azure:',
        error
      );
    }
  };

  const onLogin = data => {
    if (data.username !== '' && data.email !== '') {
      loginAzure(data)
        .then(() => {
          setIsValidUser(true);
          const savedRedirect = sessionStorage.getItem(REDIRECT_PATH_KEY);
          if (savedRedirect) {
            sessionStorage.removeItem(REDIRECT_PATH_KEY);
            props.history.replace(savedRedirect);
            return;
          }
          if (props.isWidget) {
            storeUserWidget(data);
            props.history.replace(`/widget/noticias`);
            return;
          }
          if (fromPathname) {
            props.history.replace(fromPathname);
          } else {
            props.history.replace(``);
          }
        })
        .catch(error => {
          const errorCode = Number.isNaN(parseInt(error.message, 10))
            ? '500' // Error Interno Servidor
            : error.message;
          setErrorCode(errorCode);
          setIsValidUser(false);
        });
    } else {
      setErrorCode('X');
      setIsValidUser(false);
    }
  };
  const { className } = props;
  return (
    <StyledWrapper className={className}>
      <StyledWrapperLogin className="login-wrapper">
        <React.Fragment>
          <StyledLogo svg={LogoAtresmedia} />
          {isValidUser ? (
            <div>
              <StyledTextLogin>Bienvenido/a a la Intranet </StyledTextLogin>
              <Loading size="xl" />
            </div>
          ) : (
            <div className="login-msj">
              <StyledTextLogin>
                Póngase en contacto con el equipo de Soporte
              </StyledTextLogin>
              <Alerts visible type="error">
                [{errorCode}] Usuario no válido
              </Alerts>
            </div>
          )}
        </React.Fragment>
      </StyledWrapperLogin>
    </StyledWrapper>
  );
};

export default RedirectActiveDirectory;
